import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Slide, Box, FormControl, TextField, Autocomplete } from '@mui/material';
import { getClients } from './../../../services/global_redux/globale_actions/Client.action';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DashboardModal({ open, onClose }) {
  const [client, setClient] = React.useState('');
  const [data, setData] = React.useState([]);

  const dispatch = useDispatch();
  const Navigate = useNavigate();

  const handleChange = (event, newValue) => {
    if (newValue) {
      setClient(newValue.client_id);
    }
  };

  const clientSubmit = (event) => {
    event.preventDefault();
    if (client) {
      sessionStorage.setItem('selectedClient', client);
    }
    onClose();
    const storedClientID = sessionStorage.getItem('selectedClient');
    if (storedClientID) {
      setClient(storedClientID);
      if(window.location.pathname.startsWith('/forms')){
        window.location.href = '/forms';
      }else{
          window.location.reload();
      }

    }
  };
  const cancelmodel = () => {
    const storedClientID = sessionStorage.getItem('selectedClient');
    if (storedClientID) {
      onClose();
    } else {
      onClose();
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('dashboardAlertShown');
      sessionStorage.removeItem('selectedClient');
      Navigate('/login');
      window.location.reload();
      console.log("logout successfully");
    }

  }
  const fetchClients = async () => {
    try {
      const response = await dispatch(getClients());
      const allClients = response.data; // All clients fetched from API
      const storedUser = sessionStorage.getItem('user'); // Get user from session
      if (!storedUser) {
        setData([]); // No user, so no clients to show
        return;
      }
      const user = JSON.parse(storedUser);
      let userClientIDs = [];
      if(user.client_and_unit){

        try {
          // Parse the stringified JSON to an array of client objects
          const parsedClientArray = JSON.parse(user.client_and_unit);
          // Extract the client_id from each item in the array
          userClientIDs = parsedClientArray.map(item => item.client_id);
        } catch (err) {
          console.error("Failed to parse client_id:", err);
          userClientIDs = [];
        }
      }else{
        setData([]);
        return;
      }
      if (userClientIDs.length === 0) {
        setData([]); // If the user has no assigned clients
        return;
      }
        const assignedClients = allClients.filter(client =>
        userClientIDs.includes(client.client_id) // Check if client's ID is in the user's assigned list
      );
      console.log();
      setData(assignedClients); // Set the filtered list of clients to display
    } catch (err) {
      console.error("Failed to fetch clients:", err);
      setData([]); // In case of error, clear the client list
    }
  };

  React.useEffect(() => {
    fetchClients();
  }, [dispatch]);

  React.useEffect(() => {
    const storedClientID = sessionStorage.getItem('selectedClient');
    if (storedClientID) {
      setClient(storedClientID);
    }
  }, []);

  return (
    <Dialog
    open={open}
    TransitionComponent={Transition}
    keepMounted
    onClose={(event, reason) => {
      if (reason !== 'backdropClick') {
        onClose();
      }
    }}
    maxWidth="lg"
  >
    <DialogTitle>Select The Client</DialogTitle>
    <form onSubmit={clientSubmit}>
      <DialogContent>
        <DialogContentText className='mb-3 text-bold'>
          Please select the client
        </DialogContentText>
        <Box sx={{ minWidth: 480 }}>
          <FormControl fullWidth>
            <Autocomplete
              id="client-autocomplete"
              options={data}
              getOptionLabel={(option) => option.client_name}
              onChange={handleChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Client"
                  required
                />
              )}
              noOptionsText="Client not assigned to this user"
            />
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancelmodel}>Cancel</Button>
        <Button type="submit" disabled={data.length === 0}>OK</Button>
      </DialogActions>
    </form>
  </Dialog>
  );
}
